import { settings } from './store.js';

const mq = typeof matchMedia === 'function' ? matchMedia('(prefers-color-scheme: dark)') : null;

export function isDark() {
  const s = settings();
  return s.theme === 'dark' || (s.theme === 'system' && !!(mq && mq.matches));
}

export function applySettings() {
  const s = settings();
  const root = document.documentElement;
  const dark = isDark();
  root.dataset.theme = dark ? 'dark' : 'light';
  root.dataset.text = s.textSize;
  root.dataset.sanskrit = s.sanskrit ? 'on' : 'off';
  root.dataset.iast = s.iast ? 'on' : 'off';
  setThemeColor(pageTint);
}

// Browser chrome colour: the page's own tint (a sky at the top of the page)
// when it has one, otherwise the background of the current theme.
let pageTint = null;
export function setThemeColor(tint) {
  pageTint = tint || null;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', pageTint || (isDark() ? '#0c0f1e' : '#f6f1e8'));
}

export function watchSystemTheme(fn) {
  if (mq && mq.addEventListener) mq.addEventListener('change', fn);
}

export function reducedMotion() {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
